import axios from "axios";
import { createApi } from "@reduxjs/toolkit/query/react";
import { SoftworkHttp } from "./HttpConfig";
import { StoreQueryTagEnum } from "constants/StoreConstants";

console.log(process.env.REACT_APP_API_KEY)

export const SoftwrkApi = createApi({
  reducerPath: "softwrk",
  baseQuery: axiosBaseQuery({}, SoftworkHttp),
  endpoints: (builder) => ({}),
});

[SoftwrkApi].forEach((api) => {
  api.enhanceEndpoints({ addTagTypes: Object?.values(StoreQueryTagEnum) });
});

/**
 *
 * @param {import("axios").AxiosRequestConfig} baseConfig
 */
export function axiosBaseQuery(baseConfig = {}, http = axios) {
  return request;

  /**
   *
   * @param {import("axios").AxiosRequestConfig} config
   */
  async function request(config = {}) {
    const url = config.url
      ? (baseConfig.url || "") + config.url
      : baseConfig.url;
    try {
      const response = await http.request({ ...baseConfig, ...config, url });
      // console.log(response)

      // Add X-API-Key header to the request if it's available
      // const headers = config.headers || {};
      // if (process.env.REACT_APP_API_KEY) {
      //   headers["X-API-Key"] = process.env.REACT_APP_API_KEY;
      // }

      return {
        ...response,
        data: response.data,
        message: response.data?.message || null,
        status: response.status || 200,
        meta: { request: response.request, response },
      };
    } catch (error) {
      return {
        error: error.response
          ? {
              defaultUserMessage: "",
              status: error.response.status,
              data: error.response.data,
            }
          : {
              defaultUserMessage: "Something went wrong",
              data: { defaultUserMessage: "Something went wrong" },
            },
      };
    }
  }
}
